<template>
	<div>
		<vheader v-if="!hideLayout"></vheader>
		<div id="public" class="overflow" :class="{ 'full-layout': hideLayout }">
			<div class="nav innerbox" v-if="!hideLayout">
				<el-menu :default-active="pathName" class="borderMenu" @open="handleOpen" @close="handleClose" :default-openeds='openeds' router>
          <div class="learning" v-if='newNavStatus'>
            <!-- {{newNavList}} -->
            <div v-for='(data,index) in newNavList' :key="index">
              <!-- {{data.submenu}} -->
              <div v-if="!data.submenu">
                <el-menu-item :index="item.path" v-for='(item) in data.list' :key='item.path'>
                  <i class="el-icon-menu"><img :src="item.img" /></i>
                  <span slot="title">{{item.name}}</span>
                </el-menu-item>
              </div>
              <el-submenu v-else :index="index.toString()">
                <template slot="title">
                  <i :class="data.class"></i>
                  <span>{{data.name}}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item :index="item.path" v-for='(item) in data.list' :key='item.path'>
                    <i class="el-icon-menu"><img :src="item.img" /></i>
                    <span slot="title">{{item.name}}</span>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </div>
					</div>
					<el-submenu v-else :index="index.toString()" v-for='(item,index) in navList' :key='item.path' :disabled='item.disabled'>
						<template slot="title">
							<i :class="item.class"></i>
							<span>{{item.name}}</span>
						</template>
						<el-menu-item-group>
							<el-menu-item :index="itemChild.path" v-for='(itemChild) in item.list' :key='itemChild.path'>{{itemChild.name}}</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					<a class="pathUrl" target="_blank" href="https://cschat-ccs.aliyun.com/index.htm?tntInstId=_0LT57Jw&scene=SCE00004370">在线客服</a>
					<!-- <div class="yashi" v-if='chudanStatus'>
						<p><i class="el-icon-picture"></i>操作演示</p>
						<div class="video">
							<p @click="videoFun(1)">单人出单演示</p>
							<p @click="videoFun(2)">批量出单演示</p>
							<p @click="videoFun(3)">生成激活卡链接</p>
							<p @click="videoFun(4)" v-if="ifFzjg != 4">实体卡管理</p>
							<p @click="videoFun(5)" v-if="ifFzjg != 4">实体卡下单</p>
							<p @click="videoFun(6)">自助二维码生成</p>
						</div>
					</div> -->
         
				</el-menu>
			</div>
			<div class="views" :class="{ 'full-views': hideLayout }">
				<el-breadcrumb v-if="!hideBreadcrumb" separator-class="el-icon-arrow-right" class='mbx'>
				  <el-breadcrumb-item :to="{ path: '/shop' }">首页</el-breadcrumb-item>
				  <el-breadcrumb-item v-for='(item,index) in routeName' :key='index'>{{item.name}}</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="childView">
					<router-view :category1="category"/>
				</div>
				<div class="videoBox" v-show="videoShow">
					<p @click="videoShow=false" class="el-icon-circle-close-outline"></p>
					<video :src="viseoSrc" controls="controls"></video>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import vheader from '@/components/header/inheader.vue'
  import { getInfo } from '@/axios/api.js'
	export default {
		data() {
			return {
        category:0,
				openeds: ['0','1'],
				close:['2'],
				uniqueOpened: false,
				chudanStatus:false,
				routeName:[],
				pathName:'',
        navList:[],
        newNavList: [],
				navList1:[
          {
            submenu: false,
            list: [
              {name:'店铺首页',path:'/shop',img: require('./img/shop1.png')},
              {name:'清单销售',path:'/shop/productSales',img: require('./img/shop2.png')},
              {name:'订单记录',path:'/shop/order',img: require('./img/shop3.png')},
              {name:'客户查询',path:'/shop/Orderdetails1',img: require('./img/shop4.png')}
            ]
          },
          {
            submenu: true,
            name: '实体卡销售',
            class:'el-icon-document',
            list: [
              {name:'实体卡激活',path:'/shop/activation',img: require('./img/shop5.png')},
              {name:'实体卡激活记录',path:'/shop/activationList',img: require('./img/shop5.png')}
            ]
          }

					// {name:'店铺',class:'el-icon-star-off',
					// 	list:[
					// 		{name:'店铺首页',path:'/shop'},
					// 		{name:'清单销售',path:'/shop/productSales'},
					// 		{name:'订单记录',path:'/shop/order'},
          //     {name:'订单详情',path:'/shop/Orderdetails1'}
					// 	]
					// },
					// {name:'实体卡销售',class:'el-icon-document',
					// 	list:[
					// 		{name:'实体卡激活',path:'/shop/activation'},
          //     {name:'实体卡激活记录',path:'/shop/activationList'}
					// 	]
					// },
					// {name:'意见反馈',class:'el-icon-document',
					// 	list:[
					// 		{name:'联系我们',path:'/shop/submit'}
					// 	]
					// }
				],
				navList11:[
          {
            submenu: false,
            list: [
              {name:'店铺首页',path:'/shop',img: require('./img/shop1.png')},
              {name:'清单销售',path:'/shop/productSales',img: require('./img/shop2.png')},
              {name:'订单记录',path:'/shop/order',img: require('./img/shop3.png')},
              {name:'客户查询',path:'/shop/Orderdetails1',img: require('./img/shop4.png')}
            ]
          }
					// {name:'店铺',class:'el-icon-star-off',
					// 	list:[
					// 		{name:'店铺首页',path:'/shop'},
					// 		{name:'清单销售',path:'/shop/productSales'},
					// 		{name:'订单记录',path:'/shop/order'},
          //     {name:'订单详情',path:'/shop/Orderdetails1'}
					// 	]
					// },
					// {name:'意见反馈',class:'el-icon-document',
					// 	list:[
					// 		{name:'联系我们',path:'/shop/submit'}
					// 	]
					// }
				],
				navList2:[
					{name:'商品',class:'el-icon-goods',
						list:[
							{name:'已签约商品',path:'/commodity'},
							// {name:'二维码批量下载',path:'/commodity/ewmDown'},
						]
					},
					{name:'实体卡',class:'el-icon-news',
						list:[
							{name:'下单',path:'/commodity/card'},
							{name:'购买记录',path:'/commodity/buyList'}
						]
					},
					{name:'营销材料',class:'el-icon-tickets',
						list:[
							{name:'营销材料列表',path:'/commodity/marketList'},
							// {name:'采购商品(尚未开通)',path:'/commoditys'},
						]
					},
					{name:'统计',class:'el-icon-edit',
						list:[
							{name:'实体卡销售统计',path:'/commodity/cardstatistical'},
							{name:'虚拟卡销售统计',path:'/commodity/statistical'}
						]
					},
				],
				navList21:[
					{name:'商品',class:'el-icon-goods',
						list:[
							{name:'已签约商品',path:'/commodity'},
							// {name:'采购商品(尚未开通)',path:'/commoditys'},
						]
					},
					{name:'营销材料',class:'el-icon-tickets',
						list:[
							{name:'营销材料列表',path:'/commodity/marketList'},
							// {name:'采购商品(尚未开通)',path:'/commoditys'},
						]
					},
					{name:'统计',class:'el-icon-edit',
						list:[
							{name:'虚拟卡销售统计',path:'/commodity/statistical'}
						]
					},
				],
				navList3:[
					{name:'账单',class:'el-icon-tickets',
						list:[
							{name:'结算账单',path:'/financial'},
							{name:'退单记录',path:'/financial/exit'}
						]
					},
          {name:'礼品卡',class:'el-icon-document',
          	list:[
          		{name:'礼品卡销售',path:'/financial/liveCard'}
          	]
          },
					{name:'结算',class:'el-icon-tickets',
						list:[
							{name:'结算申请',path:'/financial/settlement'},
							{name:'结算记录',path:'/financial/settlementList'},
							{name:'可结算订单查询',path:'/financial/allowList'},
							{name:'开发票',path:'/financial/fapiao'},
							{name:'开票记录',path:'/financial/invoiceList'},
						],
						disabled:false
					},
           

				],
				navList31:[
					{name:'账单',class:'el-icon-tickets',
						list:[
							{name:'结算账单',path:'/financial'},
							{name:'退单记录',path:'/financial/exit'}
						]
					}
				],
				navList4:[
					{name:'设置',class:'el-icon-setting',
						list:[
							{name:'机构信息',path:'/setting'},
							{name:'员工设置',path:'/setting/peopleSetting'},
							{name:'渠道管理',path:'/setting/channelSetting'},
              {name:'商品管理',path:'/setting/goods'},
							{name:'实体卡地址管理',path:'/setting/addrAdd'},
              {name:'Pos机管理',path:'/setting/posAdministration'},
              {name:'江泰账户信息',path:'/setting/accout'},
              {name:'通知公告',path:'/setting/notice'},
              {name:'修改密码',path:'/setting/declassify'},
						]
					}
				],
				navList41:[
					{name:'设置',class:'el-icon-setting',
						list:[
							{name:'机构信息',path:'/setting'},
							{name:'员工设置',path:'/setting/peopleSetting'},
							{name:'渠道管理',path:'/setting/channelSetting'},
              {name:'商品管理',path:'/setting/goods'},
							{name:'门店签约',path:'/setting/storesSign'},
							{name:'实体卡地址管理',path:'/setting/addrAdd'},
              {name:'Pos机管理',path:'/setting/posAdministration'},
              {name:'江泰账户信息',path:'/setting/accout'},
              {name:'通知公告',path:'/setting/notice'},
              {name:'修改密码',path:'/setting/declassify'},
						]
					}
				],
				navList42:[
					{name:'设置',class:'el-icon-setting',
						list:[
							{name:'机构信息',path:'/setting'},
							{name:'员工设置',path:'/setting/peopleSetting'},
              {name:'渠道管理',path:'/setting/channelSetting'},
              {name:'商品管理',path:'/setting/goods'},
              {name:'Pos机管理',path:'/setting/posAdministration'},
              {name:'江泰账户信息',path:'/setting/accout'},
              {name:'通知公告',path:'/setting/notice'},
              {name:'修改密码',path:'/setting/declassify'},
						]
					}
				],
				navList5:[
					{name:'门店',class:'el-icon-setting',
						list:[
							{name:'销售统计',path:'/stores/tj'},
							{name:'门店维护',path:'/stores/storesList'},
							{name:'门店审核',path:'/stores'}
						]
					}
        ],
        navList6:[
          {
            submenu: false,
            list: [
              {name:'产品介绍',path:'/learning',img: require('./img/learning1.png')},
              {name:'营销案例',path:'/learning/marketing',img: require('./img/learning2.png')},
              {name:'经验学习',path:'/learning/experience',img: require('./img/learning3.png')},
              {name:'系统操作',path:'/learning/operate',img: require('./img/learning4.png')}
            ]
          }
        ],
        newNavStatus: false,
				videoShow:false,
				viseoSrc:'http://api.dev.dajiuxing.com.cn/mp4/video/more.mp4 ',
				ifFzjg:'',
				hideLayout: false, // 是否隐藏侧边栏和头部
				hideBreadcrumb: false // 是否隐藏面包屑导航
			}
		},
		components:{
			vheader
		},
		methods: {
			pathFun(){
				var path=this.$route.fullPath
				var reg1=/shop/;
				var reg2=/commodity/;
				var reg3=/financial/;
				var reg4=/setting/;
        var reg5=/stores/;
        var reg6=/learning/;
				var virtualAccount='';
				if(JSON.parse(window.localStorage.getItem("token"))){
					this.ifFzjg=JSON.parse(window.localStorage.getItem("token")).data.obj.category;
					virtualAccount=JSON.parse(window.localStorage.getItem("token")).data.obj.virtualAccount;
        }
        // 检查是否需要隐藏布局（只有从orderNew页面跳转过来时才隐藏）
				this.hideLayout = false;
				this.hideBreadcrumb = false;
				// 检查query参数中是否有hideLayout标识，且fromOrderNew为true
				if (this.$route.query.hideLayout === 'true' && this.$route.query.fromOrderNew === 'true') {
					this.hideLayout = true;
					this.hideBreadcrumb = true; // 从orderNew跳转过来时也隐藏面包屑
				}
        this.newNavStatus = false;
				this.chudanStatus=false
				if(path.search(reg1) > 0){//店铺
					this.newNavList=this.navList1;
					this.newNavStatus=true
					if(this.ifFzjg == 4){
						this.newNavList=this.navList11;
					}
				}else if(path.search(reg2) > 0){//商品
					this.navList=this.navList2
					if(this.ifFzjg == 4){
						this.navList=this.navList21;
					}
				}else if(path.search(reg3) > 0){//财务
					this.navList=this.navList3
					if(virtualAccount == 1 || this.ifFzjg == 4){
						this.navList=this.navList31;
					}
				}else if(path.search(reg4) > 0){//设置
					console.log(virtualAccount)
					this.navList=this.navList4
					if(virtualAccount == 1){
						this.navList=this.navList41;
					}else if(this.ifFzjg == 4){
						this.navList=this.navList42;
					}
				}else if(path.search(reg5) > 0){//们店
					this.navList=this.navList5
        }else if(path.search(reg6) > 0){//学习中心
        	this.newNavList=this.navList6;
					this.newNavStatus = true;
				}
				this.routeName=this.$route.meta;
				this.pathName=this.$route.path;
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			videoFun(index){
				this.videoShow=true;
				switch(index) {
					 case 1:
						this.viseoSrc='http://api.dev.dajiuxing.com.cn/mp4/video/single.mp4'
						break;
					 case 2:
						this.viseoSrc='http://api.dev.dajiuxing.com.cn/mp4/video/more.mp4 '
						break;
					case 3:
						this.viseoSrc='http://api.dev.dajiuxing.com.cn/mp4/video/entity/activeurl.mp4'
						break;
					case 4:
						this.viseoSrc='http://api.dev.dajiuxing.com.cn/mp4/video/entity/manager.mp4'
						break;
					case 5:
						this.viseoSrc='http://api.dev.dajiuxing.com.cn/mp4/video/entity/order.mp4'
						break;
					 default:
						this.viseoSrc='http://api.dev.dajiuxing.com.cn/mp4/video/entity/ercode.mp4'
				}
			}
		},
		mounted(){
      if(localStorage.getItem('prestore') == 1) {
        this.navList3[2].list.push( {name:'预存分销',path:'/financial/preStorage'})
      }
      this.pathFun()
      getInfo().then(res => {
        if(res.data.code == 0){
          localStorage.setItem("category", res.data.obj.category);
          this.category=res.data.obj.category;
          if(this.category == 1) {
            // 设置
            this.navList4[0].list = [{name:'机构信息',path:'/setting'},{name:'江泰账户信息',path:'/setting/accout'}];
            this.navList41[0].list = [{name:'机构信息',path:'/setting'},{name:'江泰账户信息',path:'/setting/accout'}]
            this.navList42[0].list = [{name:'机构信息',path:'/setting'},{name:'江泰账户信息',path:'/setting/accout'}]
            // 财务
            this.navList3[0].list = [
              {name:'结算账单',path:'/financial'}
            ]
            this.navList31[0].list = [
              {name:'结算账单',path:'/financial'}
            ]
            // 礼品卡
            this.navList3.splice(1,1);
            this.navList31.splice(1,1);
            this.navList3[1].list = [
              {name:'结算申请',path:'/financial/settlement'},
              {name:'结算记录',path:'/financial/settlementList'},
              {name:'可结算订单查询',path:'/financial/allowList'}
            ];
              // this.navList31[1].list = [{name:'结算申请',path:'/financial/settlement'},
              // {name:'结算记录',path:'/financial/settlementList'},
              // {name:'可结算订单查询',path:'/financial/allowList'}];
              //  this.navList3[1].list.splice(3,2);
            console.log( this.navList1)
            // this.navList1 = [{name:'店铺首页',path:'/shop',img: require('./img/shop1.png')},{name:'客户查询',path:'/shop/Orderdetails1',img: require('./img/shop2.png')}];
            // this.navList11 = [{name:'店铺首页',path:'/shop',img: require('./img/shop1.png')},{name:'客户查询',path:'/shop/Orderdetails1',img: require('./img/shop2.png')}];
            // this.navList1.splice(1,1);
          }
        }else{
          this.$message(res.deta.msg);
        }
      })
      .catch( err => {
        console.log(err)
      })
		},
		watch:{
			'$route'(to,from){
				this.pathFun()
				// if(from.fullPath == '/shop/productSales'){
				// 	this.pathName='/shop/order';
				// }
			}
		}
	}
</script>
<style>
	.el-menu-item-group__title{padding: 0;}
	.borderMenu{min-height:calc(100vh - 70px);padding-top: 20px;}
	.mbx{overflow: hidden;}

</style>
<style scoped="scoped">
	.nav {
		width: 250px;
		float: left;
		height:calc(100vh - 70px);overflow: auto;
	}
	.views{width: 100%;padding: 20px;
    min-width: 1350px;
    /* padding-left: 270px; */
    background-color: white;min-height: -webkit-calc(100vh - 70px);padding-bottom: 0;}
	.childView{margin-top: 10px;}
	#public{max-width: 1600px;
    display: flex;
    /* margin: 0 auto; */
    position: absolute;
    left: 50%;
    margin-left: -800px;
  }
	.pathUrl{margin-left: 40px;font-size: 14px;font-weight: 600;display: block;margin-top: 10px;}
	.yashi{margin-left: 20px;font-size: 14px;margin-top: 20px;}
	.yashi p{margin-bottom: 20px;cursor: pointer;}
	.videoBox{position: absolute;top: 0;left: 0;width: 100vw;height: 100vh;background: rgba(0,0,0,1);}
	.videoBox video{width: 99%;height: 99%;}
	.videoBox p{position: absolute;top: 20px;right: 20px;text-align:center;line-height: 20px;z-index: 2;cursor: pointer;color: white;font-size: 20px;}
	.yashi p .el-icon-picture{color: #999;font-size: 18px;margin-right: 10px;}
	.video{margin-left: 25px;}
  .el-menu-item [class^=el-icon-]{text-align: left;}
	/* 隐藏布局时的样式 */
	#public.full-layout {
		max-width: 100%;
		left: 0;
		margin-left: 0;
		width: 100%;
	}
	.views.full-views {
		width: 100%;
		padding: 0;
		min-width: auto;
		min-height: 100vh;
	}
	.childView.full-childView {
		margin-top: 0;
		width: 100%;
	}
  .learning .el-icon-menu:before{content: '';}
  .learning .el-menu-item.is-active i{text-indent: -18px;overflow: hidden;}
  .learning .el-menu-item.is-active img{filter: drop-shadow(18px 0px #409EFF);}
  /* .learning .el-icon-menu:before{content: '';display: inline-block;background: url("./img/learning1.png") no-repeat;vertical-align: middle;margin-right: 10px;width: 18px;height: 18px;background-size: 100% 100%;} */
</style>



// WEBPACK FOOTER //
// src/components/public/index.vue